import { Button, Divider, Flex, Popconfirm, Switch, Tag } from 'antd';
import { FC } from 'react';
import { ExclamationCircle, FolderX, PencilSquare } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';

import { CopyableText, DescriptionBlock } from '@/common/components';
import { AppRoutes, BaseQueryParams } from '@/common/interfaces';
import { CommonDrawerTitle } from '@/common/layouts';

import { SearchConsoleAccountSiteSetting, SiteDomainsAutoRegluingSetting } from '@/modules/Domains';
import { SiteContentUpdateDateTag, useGetDossierByIdSitesQuery } from '@/modules/Sites';

interface Props {
  site: BaseQueryParams<typeof useGetDossierByIdSitesQuery>['data'];
  isDeleteSiteLoading: boolean;
  isButtonsDisabled: boolean;
  isContentLastDateVisibilityLoading: boolean;
  handleDeleteSite: () => void;
  handleChangeVisibilityOfContentUpdateDate: (value: boolean) => void;
}

export const SitesDossierView: FC<Props> = ({
  site,
  isDeleteSiteLoading,
  isButtonsDisabled,
  isContentLastDateVisibilityLoading,
  handleDeleteSite,
  handleChangeVisibilityOfContentUpdateDate,
}) => {
  return (
    <>
      <CommonDrawerTitle
        onlyExtra
        extra={
          <Link to={AppRoutes.SitesEdit.replace(':siteId', site.id)}>
            <Button icon={<PencilSquare />} />
          </Link>
        }
      />

      <DescriptionBlock
        items={[
          [
            'ID',
            <CopyableText key="id" textToCopy={site.id}>
              <Tag>{site.id}</Tag>
            </CopyableText>,
          ],
        ]}
      />

      <DescriptionBlock
        items={[
          [
            'Назва',
            <CopyableText key="name" textToCopy={site.name}>
              {site.name}
            </CopyableText>,
          ],
        ]}
      />

      <DescriptionBlock
        items={[
          [
            'Дата оновлення контенту сторінки',
            <Flex key="visibilityOfContentUpdateDate" gap={8} justify="space-between" align="center" style={{ width: '100%' }}>
              <Switch
                onChange={handleChangeVisibilityOfContentUpdateDate}
                checked={site.visibilityOfContentUpdateDate}
                disabled={isButtonsDisabled}
                loading={isContentLastDateVisibilityLoading}
                checkedChildren={<span>Відобразити</span>}
                unCheckedChildren={<span>Відобразити</span>}
              />

              {site.visibilityOfContentUpdateDate && (
                <SiteContentUpdateDateTag contentUpdateDate={site.contentUpdateDate} size="small" />
              )}
            </Flex>,
          ],
        ]}
      />

      <Divider />

      <SiteDomainsAutoRegluingSetting
        siteId={site.id}
        autoRegluingsVisitor={site.autoRegluingsVisitor}
        isAutoRegluingsEnabled={site.isAutoRegluingsEnabled}
      />

      <Divider />

      <SearchConsoleAccountSiteSetting
        siteId={site.id}
        processStatus={site.searchConsoleAccountProcessStatus}
        searchConsoleAccount={site?.searchConsoleAccount}
      />

      <Divider />

      <Popconfirm
        title="Ви впевнені, що хочете видалити сайт?"
        okText="Так"
        cancelText="Скасувати"
        onConfirm={handleDeleteSite}
        disabled={isButtonsDisabled}
        okButtonProps={{ danger: true }}
        icon={<ExclamationCircle style={{ color: 'red' }} />}
      >
        <Button
          block
          type="default"
          size="small"
          danger
          icon={<FolderX />}
          disabled={isButtonsDisabled}
          loading={isDeleteSiteLoading}
        >
          Видалити
        </Button>
      </Popconfirm>
    </>
  );
};
